import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@ngxs/store';
import { getActionTypeFromInstance, State, NgxsModule, createSelector } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let ActionsExecutedState = class ActionsExecutedState {
    constructor(actions$) {
        this.actions$ = actions$;
        this.actionsExecutedSub = new Subscription();
    }
    ngxsOnInit({ patchState, getState }) {
        this.actionsExecutedSub = this.actions$
            .pipe(tap((actionContext) => {
            const actionType = getActionTypeFromInstance(actionContext.action);
            if (!actionType) {
                return;
            }
            let count = getState()?.[actionType] || 0;
            if (actionContext.status !== "DISPATCHED" /* Dispatched */) {
                count++;
            }
            patchState({
                [actionType]: count
            });
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this.actionsExecutedSub.unsubscribe();
    }
};
ActionsExecutedState.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: ActionsExecutedState, deps: [{ token: i1.Actions }], target: i0.ɵɵFactoryTarget.Injectable });
ActionsExecutedState.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: ActionsExecutedState });
ActionsExecutedState = __decorate$1([
    State({
        name: 'ngxs_actions_executed'
    })
], ActionsExecutedState);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: ActionsExecutedState, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.Actions }]; } });

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let ActionsExecutingState = class ActionsExecutingState {
    constructor(actions$) {
        this.actions$ = actions$;
        this._sub = new Subscription();
    }
    ngxsOnInit({ patchState, getState }) {
        this._sub = this.actions$
            .pipe(tap((actionContext) => {
            const actionType = getActionTypeFromInstance(actionContext.action);
            if (!actionType) {
                return;
            }
            let count = getState()?.[actionType] || 0;
            if (actionContext.status === "DISPATCHED" /* Dispatched */) {
                count++;
            }
            else if (count > 0) {
                count--;
            }
            patchState({
                [actionType]: count
            });
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this._sub.unsubscribe();
    }
};
ActionsExecutingState.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: ActionsExecutingState, deps: [{ token: i1.Actions }], target: i0.ɵɵFactoryTarget.Injectable });
ActionsExecutingState.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: ActionsExecutingState });
ActionsExecutingState = __decorate([
    State({
        name: 'ngxs_actions_executing'
    })
], ActionsExecutingState);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: ActionsExecutingState, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.Actions }]; } });

class NgxsActionsExecutingModule {
    static forRoot() {
        return {
            ngModule: NgxsActionsExecutingModule
        };
    }
}
NgxsActionsExecutingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: NgxsActionsExecutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxsActionsExecutingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.12", ngImport: i0, type: NgxsActionsExecutingModule, imports: [i1.ɵNgxsFeatureModule] });
NgxsActionsExecutingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: NgxsActionsExecutingModule, imports: [NgxsModule.forFeature([ActionsExecutingState, ActionsExecutedState])] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: NgxsActionsExecutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [NgxsModule.forFeature([ActionsExecutingState, ActionsExecutedState])]
                }]
        }] });

function actionsExecutingFn(actionTypes, state) {
    if (!actionTypes || actionTypes.length === 0) {
        if (Object.keys(state).length === 0) {
            return null;
        }
        return state;
    }
    return actionTypes.reduce((acc, type) => {
        const actionType = getActionTypeFromInstance(type);
        if (!actionType) {
            return acc;
        }
        if (state[actionType]) {
            return { ...acc, [actionType]: state[actionType] };
        }
        return acc;
    }, null);
}
function actionsExecuting(actionTypes) {
    return createSelector([ActionsExecutingState], (state) => {
        return actionsExecutingFn(actionTypes, state);
    });
}
function hasActionsExecuting(actionTypes) {
    return createSelector([ActionsExecutingState], (state) => {
        const result = actionsExecutingFn(actionTypes, state);
        return result === null ? false : Object.values(result).some((value) => value > 0);
    });
}

function actionsExecuted(actionTypes) {
    return createSelector([ActionsExecutedState], (state) => {
        if (!actionTypes || actionTypes.length === 0) {
            if (Object.keys(state).length === 0) {
                return null;
            }
            return state;
        }
        return actionTypes.reduce((acc, type) => {
            const actionType = getActionTypeFromInstance(type);
            if (!actionType) {
                return acc;
            }
            if (state[actionType]) {
                return { ...acc, [actionType]: state[actionType] };
            }
            return acc;
        }, null);
    });
}

/**
 * Generated bundle index. Do not edit.
 */

export { NgxsActionsExecutingModule, actionsExecuted, actionsExecuting, hasActionsExecuting };
